{
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "Si us plau, selecciona una conversa al panell de l’esquerra",
    "CSAT_REPLY_MESSAGE": "Si us plau, valoreu la conversa",
    "404": "Ho sentim, no podem trobar la conversa. Torneu-ho a provar",
    "SWITCH_VIEW_LAYOUT": "Canvia el disseny",
    "DASHBOARD_APP_TAB_MESSAGES": "Missatges",
    "UNVERIFIED_SESSION": "La identitat d'aquest usuari no està verificada",
    "NO_MESSAGE_1": "Uh oh! Sembla que no hi ha missatges de clients a la safata d'entrada.",
    "NO_MESSAGE_2": " per enviar un missatge a la vostra pàgina!",
    "NO_INBOX_1": "Hola! Sembla que encara no heu afegit cap safata d'entrada.",
    "NO_INBOX_2": " per començar",
    "NO_INBOX_AGENT": "Uh Oh! Sembla que no ets a cap safata d'entrada. Si us plau, poseu-vos en contacte amb l'administrador",
    "SEARCH_MESSAGES": "Cerca missatges a les converses",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "EMPTY_STATE": {
      "CMD_BAR": "per obrir el menú d'ordres",
      "KEYBOARD_SHORTCUTS": "per veure les dreceres del teclat"
    },
    "SEARCH": {
      "TITLE": "Cerca missatges",
      "RESULT_TITLE": "Resultats de la cerca",
      "LOADING_MESSAGE": "S'estan restringint les dades...",
      "PLACEHOLDER": "Escriu qualsevol text per cercar missatges",
      "NO_MATCHING_RESULTS": "No s'han trobat resultats."
    },
    "UNREAD_MESSAGES": "Missatges no Llegits",
    "UNREAD_MESSAGE": "Missatge no Llegit",
    "CLICK_HERE": "Clica aquí",
    "LOADING_INBOXES": "S'estan carregant les safates d'entrada",
    "LOADING_CONVERSATIONS": "S'estan carregant les converses",
    "CANNOT_REPLY": "No pots respondre degut a",
    "24_HOURS_WINDOW": "Restricció de finestra de missatges de 24 hores",
    "48_HOURS_WINDOW": "Restricció de finestra de missatges de 48 hores",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "NOT_ASSIGNED_TO_YOU": "Aquesta conversa no està assignada a tu. Vols assignar-te-la?",
    "ASSIGN_TO_ME": "Assigna'm",
    "BOT_HANDOFF_MESSAGE": "You are responding to a conversation which is currently handled by an assistant or a bot.",
    "BOT_HANDOFF_ACTION": "Mark open and assign to you",
    "BOT_HANDOFF_REOPEN_ACTION": "Mark conversation open",
    "BOT_HANDOFF_SUCCESS": "Conversation has been handed over to you",
    "BOT_HANDOFF_ERROR": "Failed to take over the conversation. Please try again.",
    "TWILIO_WHATSAPP_CAN_REPLY": "Només pots respondre a aquesta conversa mitjançant una plantilla de missatge a causa de",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "Restricció de finestra de missatges de 24 hores",
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won’t be able to send messages from this conversation anymore.",
    "REPLYING_TO": "Estas responent a:",
    "REMOVE_SELECTION": "Elimina la selecció",
    "DOWNLOAD": "Descarrega",
    "UNKNOWN_FILE_TYPE": "Fitxer desconegut",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file",
      "MEETING": "{sender} ha iniciat una reunió"
    },
    "UPLOADING_ATTACHMENTS": "Pujant fitxers adjunts...",
    "REPLIED_TO_STORY": "Va respondre a la teva història",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "Aquest missatge no està suportat. Pots veure aquest missatge a l'aplicació Facebook Messenger.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "Aquest missatge no està suportat. Pots veure aquest missatge a l'aplicació d'Instagram.",
    "UNSUPPORTED_MESSAGE_TIKTOK": "This message is unsupported. You can view this message on the TikTok app.",
    "UNSUPPORTED_MESSAGE_WHATSAPP": "This message is unsupported. You can view this message on the WhatsApp app.",
    "SUCCESS_DELETE_MESSAGE": "El missatge s'ha suprimit correctament",
    "FAIL_DELETE_MESSSAGE": "No s'ha pogut suprimir el missatge! Torna-ho a provar",
    "NO_RESPONSE": "Sense resposta",
    "RESPONSE": "Response",
    "RATING_TITLE": "Valoració",
    "FEEDBACK_TITLE": "Comentaris",
    "REPLY_MESSAGE_NOT_FOUND": "Missatge no disponible",
    "CARD": {
      "SHOW_LABELS": "Mostra etiquetes",
      "HIDE_LABELS": "Amaga etiquetes",
      "LABELS_COUNT": "{count} labels"
    },
    "VOICE_CALL": {
      "INCOMING_CALL": "Incoming call",
      "OUTGOING_CALL": "Outgoing call",
      "CALL_IN_PROGRESS": "Call in progress",
      "NO_ANSWER": "No answer",
      "NO_ANSWER_OUTBOUND_LABEL": "No answer",
      "NO_ANSWER_OUTBOUND_SUBTEXT": "Contact didn't pick up",
      "MISSED_CALL": "Missed call",
      "MISSED_CALL_INBOUND_SUBTEXT": "No agent picked up",
      "MISSED_CALL_DECLINED_BY": "Declined by {agentName}",
      "CALL_ENDED": "Call ended",
      "HANDLED_BY": "Handled by {agentName}",
      "NOT_ANSWERED_YET": "Not answered yet",
      "CALLING": "Calling…",
      "THEY_ANSWERED": "They answered",
      "YOU_ANSWERED": "You answered",
      "AGENT_ANSWERED": "{agentName} answered",
      "JOIN_CALL": "Join call",
      "CALL_BACK": "Call back",
      "TRANSCRIPT_SHOW_MORE": "Show more",
      "TRANSCRIPT_SHOW_LESS": "Show less"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Resoldre",
      "REOPEN_ACTION": "Tornar a obrir",
      "OPEN_ACTION": "Obrir",
      "MORE_ACTIONS": "More actions",
      "OPEN": "Més",
      "CLOSE": "Tanca",
      "DETAILS": "detalls",
      "COPY_ID_SUCCESS": "Conversation ID copied to clipboard",
      "SNOOZED_UNTIL": "Posposat fins a",
      "SNOOZED_UNTIL_TOMORROW": "Posposat fins demà",
      "SNOOZED_UNTIL_NEXT_WEEK": "Posposat fins a la setmana vinent",
      "SNOOZED_UNTIL_NEXT_REPLY": "Posposat fins a la següent resposta",
      "WHATSAPP_CALL": "Start WhatsApp call",
      "WHATSAPP_CALL_FAILED": "Could not start the WhatsApp call.",
      "VOICE_CALL": "Start call",
      "VOICE_CALL_FAILED": "Could not start the call.",
      "WHATSAPP_CALL_PERMISSION_REQUESTED": "Sent a call permission request to the contact. Try again once they accept.",
      "WHATSAPP_CALL_PERMISSION_PENDING": "Call permission request already sent recently. Try again once the contact accepts.",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "perduda",
        "DUE": "límit"
      }
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Marca com a pendent",
      "SNOOZE_UNTIL": "Posposat",
      "SNOOZE": {
        "TITLE": "Posposat fins a",
        "NEXT_REPLY": "Següent resposta",
        "TOMORROW": "Demà",
        "NEXT_WEEK": "Pròxima setmana"
      }
    },
    "MENTION": {
      "AGENTS": "Agents",
      "TEAMS": "Equips"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Posposat fins a",
      "APPLY": "Posposat",
      "CANCEL": "Cancel·la"
    },
    "PRIORITY": {
      "TITLE": "Prioritat",
      "OPTIONS": {
        "NONE": "Ningú",
        "URGENT": "Urgent",
        "HIGH": "Alta",
        "MEDIUM": "Mitjana",
        "LOW": "Baixa"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Ningú",
        "INPUT_PLACEHOLDER": "Selecciona la prioritat",
        "NO_RESULTS": "No s'ha trobat agents",
        "SUCCESSFUL": "S'ha canviat la prioritat de l'ID de conversa {conversationId} a {priority}",
        "FAILED": "No s'ha pogut canviar la prioritat. Si us plau, torna-ho a provar."
      }
    },
    "DELETE_CONVERSATION": {
      "TITLE": "Delete conversation #{conversationId}",
      "DESCRIPTION": "Are you sure you want to delete this conversation?",
      "CONFIRM": "Esborrar"
    },
    "CARD_CONTEXT_MENU": {
      "PENDING": "Marca com a pendent",
      "RESOLVED": "Marca com a resolt",
      "MARK_AS_UNREAD": "Marca com a no llegit",
      "MARK_AS_READ": "Marca com a llegit",
      "REOPEN": "Torna a obrir la conversa",
      "SNOOZE": {
        "TITLE": "Posposat",
        "NEXT_REPLY": "Fins a la propera resposta",
        "TOMORROW": "Fins demà",
        "NEXT_WEEK": "Fins a la setmana vinent"
      },
      "ASSIGN_AGENT": "Assigna un agent",
      "ASSIGN_LABEL": "Assigna etiqueta",
      "AGENTS_LOADING": "S'estan carregant els agents...",
      "ASSIGN_TEAM": "Assigna un equip",
      "DELETE": "Delete conversation",
      "OPEN_IN_NEW_TAB": "Open in new tab",
      "COPY_LINK": "Copy conversation link",
      "COPY_LINK_SUCCESS": "Conversation link copied to clipboard",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Id de conversa {conversationId} assignat a \"{agentName}\"",
          "FAILED": "No s'ha pogut assignar l'agent. Torna-ho a provar."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "No s'ha pogut assignar l'etiqueta. Torna-ho a provar."
        },
        "LABEL_REMOVAL": {
          "SUCCESFUL": "Removed label #{labelName} from conversation id {conversationId}",
          "FAILED": "Couldn't remove label. Please try again."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "S'ha assignat l'equip \"{team}\" a l'id de conversa {conversationId}",
          "FAILED": "No s'ha pogut assignar l'equip. Torna-ho a provar."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Signatura del missatge",
      "ENABLE_SIGN_TOOLTIP": "Activa la signatura",
      "DISABLE_SIGN_TOOLTIP": "Desactiva la signatura",
      "MSG_INPUT": "Shift + enter per a una línia nova. Comença amb '/' per seleccionar una resposta predeterminada.",
      "PRIVATE_MSG_INPUT": "Shift + enter per una línia nova. Això serà visible només per als Agents",
      "MESSAGING_RESTRICTED": "You cannot reply to this conversation",
      "MESSAGING_RESTRICTED_WHATSAPP": "You can only reply using a template message due to 24-hour message window restriction",
      "MESSAGING_RESTRICTED_API": "You can only reply using a template message due to message window restriction",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "La signatura del missatge no està configurada, configura-la a la configuració del perfil.",
      "COPILOT_MSG_INPUT": "Dóna instruccions addicionals a copilot o pregunta qualsevol altra cosa... Prem enter per enviar un seguiment",
      "CLICK_HERE": "Fes clic aquí per actualitzar",
      "WHATSAPP_TEMPLATES": "Plantilles de Whatsapp"
    },
    "REPLYBOX": {
      "REPLY": "Respon",
      "PRIVATE_NOTE": "Nota privada",
      "SEND": "Envia",
      "CREATE": "Afegeix una nota",
      "INSERT_READ_MORE": "Llegir més",
      "DISMISS_REPLY": "Ignora la resposta",
      "REPLYING_TO": "Responent a:",
      "TIP_EMOJI_ICON": "Mostra la selecció d'emoticones",
      "TIP_ATTACH_ICON": "Ajuntar fitxers",
      "TIP_AUDIORECORDER_ICON": "Gravar àudio",
      "TIP_AUDIORECORDER_PERMISSION": "Permet l'accés a l'àudio",
      "TIP_AUDIORECORDER_ERROR": "No s'ha pogut obrir l'àudio",
      "AUDIO_CONVERSION_FAILED": "Audio conversion failed. Please try again.",
      "DRAG_DROP": "Arrossega i deixa anar aquí per adjuntar-lo",
      "START_AUDIO_RECORDING": "Inicia la gravació d'àudio",
      "STOP_AUDIO_RECORDING": "Atura la gravació d'àudio",
      "COPILOT_THINKING": "Copilot està pensant",
      "EMAIL_HEAD": {
        "TO": "A",
        "ADD_BCC": "Afegeix cco",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "Correus electrònics separats per comes",
          "ERROR": "Introduïu adreces de correu electrònic vàlides"
        },
        "BCC": {
          "LABEL": "CCO",
          "PLACEHOLDER": "Correus electrònics separats per comes",
          "ERROR": "Introduïu adreces de correu electrònic vàlides"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Variables sense definir",
        "MESSAGE": "Tens {undefinedVariablesCount} variables sense definir al teu missatge: {undefinedVariables}. Vols enviar el missatge igualment?",
        "CONFIRM": {
          "YES": "Envia",
          "CANCEL": "Cancel·la"
        }
      },
      "QUOTED_REPLY": {
        "ENABLE_TOOLTIP": "Include quoted email thread",
        "DISABLE_TOOLTIP": "Don't include quoted email thread",
        "REMOVE_PREVIEW": "Remove quoted email thread",
        "COLLAPSE": "Collapse preview",
        "EXPAND": "Expand preview"
      }
    },
    "VISIBLE_TO_AGENTS": "Nota privada: Només és visible per tu i el vostre equip",
    "CHANGE_STATUS": "Estat de la conversa canviat",
    "CHANGE_STATUS_FAILED": "No s'ha pogut canviar l'estat de la conversa",
    "CHANGE_AGENT": "Assignació de la conversa canviat",
    "CHANGE_AGENT_FAILED": "El canvi de l'assignat ha fallat",
    "ASSIGN_LABEL_SUCCESFUL": "L'etiqueta s'ha assignat correctament",
    "ASSIGN_LABEL_FAILED": "L'assignació d'etiquetes ha fallat",
    "CHANGE_TEAM": "L'equip de conversa ha canviat",
    "SUCCESS_DELETE_CONVERSATION": "Conversation deleted successfully",
    "FAIL_DELETE_CONVERSATION": "Couldn't delete conversation! Try again",
    "FILE_SIZE_LIMIT": "El fitxer supera el límit de {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB fitxers adjunts",
    "FILE_TYPE_NOT_SUPPORTED": "This {fileName} file type is not supported in this conversation",
    "MESSAGE_ERROR": "No es pot enviar aquest missatge, torna-ho a provar més tard",
    "SENT_BY": "Enviat per:",
    "BOT": "Bot",
    "NATIVE_APP": "Native app",
    "NATIVE_APP_ADVISORY": "This message was sent from the native app. Reply from Chatwoot to maintain the message window.",
    "SEND_FAILED": "No s'ha pogut enviar el missatge! Torna-ho a provar",
    "TRY_AGAIN": "reintenta",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Seleccionar Agent",
      "REMOVE": "Suprimeix",
      "ASSIGN": "Assignar"
    },
    "CONTEXT_MENU": {
      "COPY": "Copia",
      "REPLY_TO": "Respon a aquest missatge",
      "DELETE": "Esborrar",
      "CREATE_A_CANNED_RESPONSE": "Afegir a les respostes predeterminades",
      "TRANSLATE": "Tradueix",
      "COPY_PERMALINK": "Copia l'enllaç al missatge",
      "LINK_COPIED": "URL del missatge copiat al porta-retalls",
      "DELETE_CONFIRMATION": {
        "TITLE": "Estàs segur que vols suprimir aquest missatge?",
        "MESSAGE": "No pots desfer aquesta acció",
        "DELETE": "Esborrar",
        "CANCEL": "Cancel·la"
      }
    },
    "SIDEBAR": {
      "CONTACT": "Contacte",
      "COPILOT": "Copilot"
    },
    "VOICE_WIDGET": {
      "INCOMING_CALL": "Incoming call",
      "OUTGOING_CALL": "Outgoing call",
      "CALL_IN_PROGRESS": "Call in progress",
      "NOT_ANSWERED_YET": "Not answered yet",
      "HANDLED_IN_ANOTHER_TAB": "Being handled in another tab",
      "REJECT_CALL": "Reject",
      "DISMISS_CALL": "Descartar",
      "JOIN_CALL": "Join call",
      "END_CALL": "End call",
      "MUTE": "Mute mic",
      "UNMUTE": "Unmute mic",
      "VIEW_CHAT_HISTORY": "View chat history",
      "GO_TO_CONVERSATION": "Go to conversation thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Envia la transcripció de la conversa",
    "DESC": "Envia una còpia de la transcripció de la conversa a l'adreça electrònica especificada",
    "SUBMIT": "Envia",
    "CANCEL": "Cancel·la",
    "SEND_EMAIL_SUCCESS": "La transcripció del xat s'ha enviat correctament",
    "SEND_EMAIL_ERROR": "S'ha produït un error; tornau-ho a provar",
    "SEND_EMAIL_PAYMENT_REQUIRED": "Email transcript is not available on your current plan. Please upgrade to use this feature.",
    "FORM": {
      "SEND_TO_CONTACT": "Envia la transcripció al client",
      "SEND_TO_AGENT": "Envia la transcripció a l'agent assignat",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Envia la transcripció a una altra adreça electrònica",
      "EMAIL": {
        "PLACEHOLDER": "Introdueix una adreça de correu electrònic",
        "ERROR": "Introduïu una adreça de correu electrònic vàlida"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Hola 👋, Benvingut a {installationName}!",
    "DESCRIPTION": "Gràcies per registrar-te. Volem que treguis el màxim profit de {installationName}. Aquí teniu algunes coses que pots fer a {installationName} perquè l'experiència sigui agradable.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "Llegiu les nostres últimes actualitzacions",
    "ALL_CONVERSATION": {
      "TITLE": "Totes les teves converses en un sol lloc",
      "DESCRIPTION": "Consulta totes les converses dels teus clients en un únic tauler. Podeu filtrar les converses pel canal d'entrada, l'etiqueta i l'estat.",
      "NEW_LINK": "Fes clic aquí per crear una safata d'entrada"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Convida els membres del teu equip",
      "DESCRIPTION": "Com que us esteu preparant per parlar amb el vostre client, feu venir els vostres companys d'equip per ajudar-vos. Pots convidar els teus companys d'equip afegint les seves adreces de correu electrònic a la llista d'agents.",
      "NEW_LINK": "Feu clic aquí per convidar un membre de l'equip"
    },
    "LABELS": {
      "TITLE": "Organitza converses amb etiquetes",
      "DESCRIPTION": "Les etiquetes proporcionen una manera més fàcil de classificar la vostra conversa. Crea algunes etiquetes com #consulta-suport, #pregunta-facturació, etc., perquè les puguis utilitzar en una conversa més endavant.",
      "NEW_LINK": "Fes clic aquí per crear etiquetes"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Agent assignat",
    "SELF_ASSIGN": "Assigna-me-la",
    "TEAM_LABEL": "Assignada a un equip",
    "SELECT": {
      "PLACEHOLDER": "Ningú"
    },
    "ACCORDION": {
      "CONTACT_DETAILS": "Detalls de contacte",
      "CONVERSATION_ACTIONS": "Accions de conversa",
      "CONVERSATION_LABELS": "Etiquetes de converses",
      "CONVERSATION_INFO": "Informació de la conversa",
      "CONTACT_NOTES": "Contact Notes",
      "CONTACT_ATTRIBUTES": "Atributs de contacte",
      "PREVIOUS_CONVERSATION": "Converses prèvies",
      "MACROS": "Macros",
      "LINEAR_ISSUES": "Linked Linear Issues",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "SHARED_FILES": "Attachments"
    },
    "SHARED_FILES": {
      "EMPTY": "No attachments yet",
      "DOWNLOAD": "Download file",
      "DOWNLOAD_ERROR": "Could not download the file. Please try again.",
      "MEDIA_HEADING": "Media",
      "FILES_HEADING": "Files",
      "VIEW_ALL": "Veure tot",
      "SHOW_LESS": "Show less",
      "MORE_COUNT": "+{count}",
      "UNTITLED_FILE": "Untitled file"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Pendent",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Crea atribut",
    "NO_RECORDS_FOUND": "No s'han trobat atributs",
    "UPDATE": {
      "SUCCESS": "Atribut actualitzat correctament",
      "ERROR": "No es pot actualitzar l'atribut. Si us plau, intenta-ho més tard"
    },
    "ADD": {
      "TITLE": "Afegir",
      "SUCCESS": "Atribut afegit correctament",
      "ERROR": "No es pot afegir l'atribut. Si us plau, intenta-ho més tard"
    },
    "DELETE": {
      "SUCCESS": "Atribut esborrat correctament",
      "ERROR": "No es pot esborrar l'atribut. Si us plau, intenta-ho més tard"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Afegir atributs",
      "PLACEHOLDER": "Cerca atributs",
      "NO_RESULT": "No s'han trobat atributs"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "Des de",
    "TO": "Per",
    "BCC": "Cco",
    "CC": "Cc",
    "SUBJECT": "Assumpte",
    "EXPAND": "Expand email"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Participant",
    "SIDEBAR_TITLE": "Participants de la conversa",
    "NO_RECORDS_FOUND": "No s'ha trobat agents",
    "ADD_PARTICIPANTS": "Selecciona els participants",
    "REMANING_PARTICIPANTS_TEXT": "+{count} més",
    "REMANING_PARTICIPANT_TEXT": "+{count} més",
    "TOTAL_PARTICIPANTS_TEXT": "{count} persones estan participant.",
    "TOTAL_PARTICIPANT_TEXT": "{count} persona està participant.",
    "NO_PARTICIPANTS_TEXT": "No hi participa ningú!",
    "WATCH_CONVERSATION": "Uneix-te a la conversa",
    "YOU_ARE_WATCHING": "Estàs participant",
    "API": {
      "ERROR_MESSAGE": "No s'ha pogut actualitzar, torna-ho a provar!",
      "SUCCESS_MESSAGE": "Participants actualitzats!"
    }
  },
  "TRANSLATE_MODAL": {
    "TITLE": "Veure contingut traduït",
    "DESC": "Pots veure el contingut traduït a cada idioma.",
    "ORIGINAL_CONTENT": "Contingut original",
    "TRANSLATED_CONTENT": "Contingut traduït",
    "NO_TRANSLATIONS_AVAILABLE": "No hi ha traduccions disponibles per a aquest contingut"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  }
}
